import styles from './PageNotFound.module.css';

const LoginSuccessPage = () => {
  return (
    <div className={styles.main}>
      <div className={styles.fof}>
        <h4>Successfully Logged in!!!!</h4>
      </div>
    </div>
  );
};

export default LoginSuccessPage;